import { WorkspaceDatabaseKeys } from '@database/workspace';
import { ErrorCodes, fileBooleanMappings } from '@shared';
import { firstValueFrom, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DeleteIntervalService } from '../services';
import { ValidationKeys } from '../../../../dynamic-form/validations/models';
import { DeleteChainParams, IDeleteValidatorHandler, IValidationsRule } from './models';
import { LoggingService } from '@shared/logging';

export class GapsCheck implements IDeleteValidatorHandler {
	private next: IDeleteValidatorHandler;

	public constructor(
		private deleteDataService: DeleteIntervalService,
		private loggerService: LoggingService
	) {}

	public setNext(nextHandler: IDeleteValidatorHandler) {
		this.next = nextHandler;
	}

	public async handle(deleteChainParams: DeleteChainParams): Promise<IValidationsRule | null> {
		try {
			const gapCheck: IValidationsRule | null = await firstValueFrom(
				of(fileBooleanMappings[deleteChainParams.tableMetadata[WorkspaceDatabaseKeys.tables.allowGaps]]).pipe(
					switchMap((allowGap: boolean) => {
						if (!allowGap) {
							return this.deleteDataService
								.isGapInData$(
									deleteChainParams.tableName,
									deleteChainParams.workfileId,
									deleteChainParams.projectNumber,
									deleteChainParams.entityName,
									deleteChainParams.entryId,
									deleteChainParams.childEntryId,
									deleteChainParams.depthFrom,
									deleteChainParams.depthTo
								)
								.pipe(
									map((gapFound: boolean) =>
										gapFound
											? { validationKey: ValidationKeys.validationRules.intervalGapRule }
											: null
									)
								);
						}
						return of(null);
					})
				)
			);

			if (gapCheck) {
				return gapCheck;
			}

			if (this.next) {
				return this.next.handle(deleteChainParams);
			}

			return null;
		} catch (error) {
			this.loggerService.error(ErrorCodes.DeleteGapError, error);
			throw error;
		}
	}
}
